import { ChangeDetectionStrategy, Component, HostListener, Input, OnInit } from '@angular/core'

import { ILicense, ILicenseBulkDiscount, LicenseBtnNameType } from '../../../Interface/license'
import { CartService } from '../../../services/cart.service'
import { RoutingPathService } from '../../../services/environment.service'
import { NotificationService } from '../../../services/notification.service'
import { I18nService, LgType } from '../../../services/prod/i18n.service'
import { TrackInCartService } from '../../../services/track-in-cart.service'

@Component({
  selector: 'bmcore-license-item',
  templateUrl: './bmcore-license-item.component.html',
  styleUrls: ['./bmcore-license-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreLicenseItemComponent implements OnInit {
  @Input() license: ILicense
  @Input() licenseBulkDiscounts: ILicenseBulkDiscount[] = []
  @Input() toBeatListBtnRoute = ''
  @Input() btnInLicenseName: LicenseBtnNameType

  lg: LgType
  mobMode = false
  language: string
  checkoutPage: string

  constructor(
    private i18nService: I18nService,
    private cartService: CartService,
    private trackInCartService: TrackInCartService,
    private notificationService: NotificationService,
    private routingPathService: RoutingPathService
  ) {
    this.checkoutPage = this.routingPathService.getCheckoutUrl()
  }

  ngOnInit() {
    this.lg = this.i18nService.getLanguageForPage()
    this.language = this.i18nService.language
    this.onResize()
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    const mobViewPort = 767
    this.mobMode = window.innerWidth < mobViewPort
  }

  addTrackToCart(beatId: number, licenseId: string) {
    this.showNotification()
    this.cartService.addBeat(beatId, licenseId)
  }

  checkIsTrackWithSelectedLicenseInCart(beatId: number, licenseId: string): boolean {
    return this.trackInCartService.checkIsTrackWithSelectedLicenseInCart(beatId, licenseId)
  }

  showNotification() {
    this.notificationService.handleInfo(this.lg.cartPage.beatAddedToCart)
  }
}
